import type React from "react";

interface InformationIcon {
  width: string;
  height: string;
}

export const InformationIcon: React.FC<InformationIcon> = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7.5" cy="7.5" r="7" stroke="#2D2D2D" />
      <path
        d="M6.85653 12V5.45455H8.13068V12H6.85653ZM7.5 4.4446C7.27841 4.4446 7.08807 4.37074 6.92898 4.22301C6.77273 4.07244 6.6946 3.89347 6.6946 3.68608C6.6946 3.47585 6.77273 3.29687 6.92898 3.14915C7.08807 2.99858 7.27841 2.9233 7.5 2.9233C7.72159 2.9233 7.91051 2.99858 8.06676 3.14915C8.22585 3.29687 8.3054 3.47585 8.3054 3.68608C8.3054 3.89347 8.22585 4.07244 8.06676 4.22301C7.91051 4.37074 7.72159 4.4446 7.5 4.4446Z"
        fill="#2D2D2D"
      />
    </svg>
  );
};
